import { Accordion, AccordionSummary, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Stack, TextField } from "@mui/material";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "../../../../pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, get, isArray, isEqual, min, set } from "lodash";
import LightTooltip from "../../../../commonComponents/LightTooltip";
import LabeledDropDown from "../../../TemplateProperties/TPDropDown";
import { api } from "../../../../redux/api";
import axios from "axios";
import OutboundConditionModal from "./OutboundConditionModal";
import { treeActions } from "../../../../redux/slices/treeSlice";

// Helper functions for template name handling
const addJsonExtension = (templateName) => {
  if (!templateName || ['SELECT', 'EMPTY_COMBO'].includes(templateName)) return null;
  return templateName.endsWith('.json') ? templateName : `${templateName}.json`;
};

const removeJsonExtension = (templateName) => {
  if (!templateName) return '';
  return templateName.endsWith('.json') ? templateName.slice(0, -5) : templateName;
};

//get compatible outbound templates. view button redirects to that template in outbound page
export default function TDataOutboundDependency({ treeData, setTreeData, treeSelectedNode, setTreeSelectedNode, parentNode, onValidationChange }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { account, user, baseUrl, token } = useSelector((state) => state.queryParams);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);

  const outboundTemplatesTree = useSelector(
    (state) => state.treeData.outbound.leftTree.tree.body.translatedData
  );

  //save function. clone data, find node in tdata, change obj, dispatch new tdata and selnode
  const submitChange = (key, value, bulk, removeValues) => {
    if (!key && !removeValues && !bulk) return;
    // Clone and deeply iterate through the tree data to update the relevant node.
    const updatedData = eachDeep(cloneDeep(treeData), (obj) => {
      // if (obj?.key !== treeSelectedNode?.key) return;

      if (obj?.key === treeSelectedNode?.key) {

        if (bulk) {
          bulk.forEach((item) => {
            if (item.value === null) {
              if (obj?.hasOwnProperty(item.key)) delete obj[item.key];
            } else {
              if (obj?.hasOwnProperty(item.key)) obj[item.key] = item.value;
              else obj[item.key] = item.value;
            }
          });
        } else {
          // Update properties directly on the object.
          if (value === null) {
            if (obj?.hasOwnProperty(key)) delete obj[key];
          } else {
            if (key === "TEMPLATE") {
              if (value === "") {
                obj[key] = value;
                obj.tval = value;
              } else {
                obj[key] = `${value.split("/")[1]}.json`;
                obj.tval = `${value.split("/")[1]}.json`;
                obj["TEMPLATE_LOCATION"] = `${account}/${value.split("/")[0]}/outbound_templates`;
              }
            } else {
              obj[key] = value;
            }
          }
        }


        setTreeSelectedNode(obj);
      }

      // If the object has children, return them for further iteration.
      if (isArray(obj?.children)) {
        return obj.children;
      }
    });

    setTreeData(updatedData);
  };

  const debounceChangeHandler = useCallback(debounce(submitChange, 100), [rightTree.tree]);


  //***logic for Template Group dropdown ***/
  // const templateGroupFlatArr = inboundTemplatesTree?.filter((node) => node?.type === "workflowGroup").map(obj => obj.title) || [];

  // let wfGroups = [
  //   <MenuItem key={'SELECT'} value={'SELECT'}>
  //     { t("SELECT")}
  //   </MenuItem>
  // ];

  // if (templateGroupFlatArr) {
  //   templateGroupFlatArr.forEach((ele) => {
  //     wfGroups.push(
  //       <MenuItem key={ele} value={ele}>
  //         {ele}
  //       </MenuItem>
  //     );
  //   });
  // }

  // const templateGroupOptions = wfGroups?.length > 0 ? 
  //   wfGroups 
  //   : [
  //     <MenuItem key={'EMPTY_COMBO'} value={'EMPTY_COMBO'}>
  //       { t("EMPTY_COMBO")}
  //     </MenuItem>
  //   ]; 

  // const currentTemplateGroup = treeSelectedNode?.TEMPLATE_LOCATION ? treeSelectedNode.TEMPLATE_LOCATION.split("/")[1] : "";

  // const templateGroupDefault = (currentTemplateGroup && templateGroupFlatArr.includes(currentTemplateGroup)) ? 
  //   currentTemplateGroup 
  //   : templateGroupOptions[0]?.props?.value;


  // const [templateGroupValue, setTemplateGroupValue] = useState(templateGroupDefault);


  //*** logic for Template dropdown */
  const currentSelectedTemplate = treeSelectedNode?.TEMPLATE ? removeJsonExtension(treeSelectedNode.TEMPLATE) : "";
  // const templatesForWfGroup = outboundTemplatesTree?.filter((node) => node?.type === "workflowGroup" && node?.title === templateGroupValue)[0]?.children || [];

  let templateMenuOptionsArr = [
    <MenuItem key={'SELECT'} value={'SELECT'}>
      {t("SELECT")}
    </MenuItem>
  ]

  // if (templatesForWfGroup?.length > 0) {
  //   templatesForWfGroup.forEach((ele) => {
  //     templateMenuOptionsArr.push(
  //       <MenuItem key={ele.title} value={ele.title}>
  //         {ele.title.split(".")[0]}
  //       </MenuItem>
  //     );
  //   });
  // }

  const [templateOptions, setTemplateOptions] = useState([]);

  const [templateValue, setTemplateValue] = useState(t("EMPTY_COMBO"));
  const [templateListStr, setTemplateListStr] = useState([]);

  const [templateWfGroup, setTemplateWfGroup] = useState(treeSelectedNode?.TEMPLATE_LOCATION?.split("/")?.[1]);
  const [templateName, setTemplateName] = useState(removeJsonExtension(treeSelectedNode?.TEMPLATE));
  const [obTemplateListLoading, setObTemplateListLoading] = useState(true);

  // raw value from the json , or empty
  let rawTemplateValue = templateValue;

  if (treeSelectedNode?.TEMPLATE && treeSelectedNode?.TEMPLATE_LOCATION) {
    rawTemplateValue = `${treeSelectedNode.TEMPLATE_LOCATION.split("/")[1]}/${removeJsonExtension(treeSelectedNode.TEMPLATE)}`;
  }

  // Check if template exists in the fetched template list
  const templateExistsObTemplatesTree = templateListStr.includes(rawTemplateValue);

  // If template doesn't exist in the list and we have other templates available, show "SELECT"
  // If no templates are available at all, show "EMPTY_COMBO"
  // But only if the current template is not already a valid selection
  if (!templateExistsObTemplatesTree && rawTemplateValue !== "EMPTY_COMBO" && rawTemplateValue !== "SELECT") {
    if (templateListStr.length > 1) { // More than just "EMPTY_COMBO"
      rawTemplateValue = "SELECT";
    } else {
      rawTemplateValue = "EMPTY_COMBO";
    }
  }

  // Track the currently selected template value for button state
  const [selectedTemplateValue, setSelectedTemplateValue] = useState(rawTemplateValue);

  // Check if current template selection is valid
  const isValidTemplate = () => {
    return templateExistsObTemplatesTree && 
           !["SELECT", "EMPTY_COMBO"].includes(rawTemplateValue) &&
           templateListStr.length > 1; // More than just "EMPTY_COMBO"
  };

  // Only show templates that exist in the outbound templates tree
  let correctedDropdownOptions = [...templateOptions];

  // If we have templates available (more than just "EMPTY_COMBO"), show "SELECT" option
  // If no templates are available, show "EMPTY_COMBO" option
  if (templateListStr.length > 1) {
    // We have templates available, show "SELECT" option
    if (!correctedDropdownOptions.some(option => option.props?.value === "SELECT")) {
      correctedDropdownOptions.unshift(
        <MenuItem key={'SELECT'} value={'SELECT'}>
          {t("SELECT")}
        </MenuItem>
      );
    }
  } else {
    // No templates available, show "EMPTY_COMBO" option
    if (!correctedDropdownOptions.some(option => option.props?.value === "EMPTY_COMBO")) {
      correctedDropdownOptions.unshift(
        <MenuItem key={'EMPTY_COMBO'} value={'EMPTY_COMBO'}>
          {t("EMPTY_COMBO")}
        </MenuItem>
      );
    }
  }

  // Check if the current template exists before adding it to dropdown
  if (!templateListStr.includes(rawTemplateValue) && templateExistsObTemplatesTree && rawTemplateValue !== "EMPTY_COMBO") {
    correctedDropdownOptions.push(
      <MenuItem key={rawTemplateValue} value={rawTemplateValue}>
        {rawTemplateValue}
      </MenuItem>
    )
  }

  useEffect(() => {
    setTemplateWfGroup(treeSelectedNode?.TEMPLATE_LOCATION?.split("/")?.[1]);
    setTemplateName(removeJsonExtension(treeSelectedNode?.TEMPLATE));
    // Update selectedTemplateValue when treeSelectedNode changes
    if (treeSelectedNode?.TEMPLATE && treeSelectedNode?.TEMPLATE_LOCATION) {
      const newRawValue = `${treeSelectedNode.TEMPLATE_LOCATION.split("/")[1]}/${removeJsonExtension(treeSelectedNode.TEMPLATE)}`;
      setSelectedTemplateValue(newRawValue);
      
      // Don't clear template value even if not found - keep it in JSON for display
      // Only update selectedTemplateValue for UI purposes
      if (templateListStr.length > 0 && !templateListStr.includes(newRawValue) && newRawValue !== "EMPTY_COMBO" && newRawValue !== "SELECT") {
        // Don't clear the template from JSON, just update UI state
        if (templateListStr.length > 1) {
          setSelectedTemplateValue("SELECT");
        } else {
          setSelectedTemplateValue("EMPTY_COMBO");
        }
      }
    } else if (!treeSelectedNode?.TEMPLATE && !treeSelectedNode?.TEMPLATE_LOCATION) {
      // If no template is set, set to appropriate default
      if (templateListStr.length > 1) {
        setSelectedTemplateValue("SELECT");
      } else {
        setSelectedTemplateValue("EMPTY_COMBO");
      }
    }
  }, [treeSelectedNode, templateListStr]);

  // Notify parent component when validation state changes
  useEffect(() => {
    if (onValidationChange) {
      const validTemplate = isValidTemplate();
      onValidationChange(validTemplate);
    }
  }, [templateExistsObTemplatesTree, rawTemplateValue, templateListStr, onValidationChange]);

  const handleTemplateChange = (e) => {
    if (!e.target?.value) return;
    setTemplateValue(e.target.value);
    setSelectedTemplateValue(e.target.value);
    const templateValue = e.target.value === "EMPTY_COMBO" || e.target.value === "SELECT" ?
      null : e.target.value;
    debounceChangeHandler('TEMPLATE', templateValue);
    
    // Immediately update validation state
    if (onValidationChange) {
      const isValidSelection = templateValue !== null && 
                              !["EMPTY_COMBO", "SELECT"].includes(e.target.value) &&
                              templateListStr.includes(e.target.value);
      onValidationChange(isValidSelection);
    }
  };

  const handleViewTemplateClick = () => {
    if (templateExistsObTemplatesTree) {
      dispatch(treeActions.setCurrentScreen("outbound"));
      dispatch(treeActions.setForceTemplate({
        workflowGroup: templateWfGroup,
        template: templateName,
        screen: "outbound"
      }));
    }
  };

  // const handleOutboundModalSave = (newData) => {
  //   if (!newData) return;

  //   debounceChangeHandler("CONDITION", newData);
  // };


  useEffect(() => {
    const requestUrl = `${baseUrl}/workbench`;
    const wfGroupName = parentNode?.TEMPLATE_LOCATION?.split("/")?.[1];
    const inbound = removeJsonExtension(parentNode?.TEMPLATE);

    if (!wfGroupName || !inbound) {
      //params not valid
      //clear loading state incase it was true when moving to another node too quickly, then return
      setObTemplateListLoading(false);
      return;
    }

    const urlParams = {
      action: 'get_outbound_templates_for_inbound',
      user: user,
      account: account,
      workflow_group_name: wfGroupName,
      inbound: inbound,
    }
    setObTemplateListLoading(true);
    axios.get(requestUrl, {
      params: urlParams,
      headers: {
        "Authorization": `Bearer ${token}`
      },
    }).then((response) => {
      //response is returning empty
      // console.log("response", response);
      if (response?.data?.outbound_templates?.length > 0) {
        handleSuccess(response?.data?.outbound_templates);
      } else {
        console.warn("Error fetching ob templates for ib", response);
      }
      setObTemplateListLoading(false);
    }).catch((error) => {
      setObTemplateListLoading(false);
      //dev log incase this needs to be tested and handled. Will be removed later.
      console.warn("Error fetching ob templates for ib", error);
    })

    function handleSuccess(templateArr) {
      // console.log("templateArr", templateArr);
      //sort alphabetically, map to menu items and set state
      
      // If we have templates, include "SELECT" option, otherwise just "EMPTY_COMBO"
      let templateArrStringed = templateArr.length > 0 ? ["SELECT", ...templateArr] : ["EMPTY_COMBO"];
      let templateArrFinal = templateArrStringed.sort().map((ele) => {
        return (
          <MenuItem key={ele} value={ele}>
            {ele === "EMPTY_COMBO" ? t("EMPTY_COMBO") : ele === "SELECT" ? t("SELECT") : ele}
          </MenuItem>
        )
      });

      // if (
      //   treeSelectedNode?.TEMPLATE_LOCATION &&
      //   treeSelectedNode?.TEMPLATE &&
      //   templateArr?.filter(e => e === `${treeSelectedNode?.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode?.TEMPLATE?.split(".")[0]}`).length === 0
      // ) {
      //   templateArrStringed.push(
      //     `${treeSelectedNode?.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode?.TEMPLATE?.split(".")[0]}`
      //   );
      //   templateArrFinal.push(
      //     <MenuItem key={`${treeSelectedNode?.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode?.TEMPLATE?.split(".")[0]}`} value={`${treeSelectedNode?.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode?.TEMPLATE?.split(".")[0]}`}>
      //       {`${treeSelectedNode?.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode?.TEMPLATE?.split(".")[0]}`}
      //     </MenuItem>
      //   )
      // }

      setTemplateListStr(templateArrStringed);
      setTemplateOptions(templateArrFinal);
      
      // Only set default template value if no template is currently selected
      if (!treeSelectedNode?.TEMPLATE && !treeSelectedNode?.TEMPLATE_LOCATION) {
        setTemplateValue(templateArr.length > 0 ? "SELECT" : "EMPTY_COMBO");
      }
    }


  }, []);

  // useEffect(() => {
  //   //set initial template value after options are fetched from endpoint call.

  //   let newTemplateValue = "";

  //   if (treeSelectedNode?.TEMPLATE === "" || !treeSelectedNode?.TEMPLATE) {
  //     newTemplateValue = templateOptions[0]?.props?.value
  //   } else if (treeSelectedNode?.TEMPLATE && treeSelectedNode?.TEMPLATE_LOCATION) {
  //     if (templateOptions.map(node => node.props.value).includes(`${treeSelectedNode.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode.TEMPLATE?.split(".")?.[0]}`)) {
  //       newTemplateValue = `${treeSelectedNode.TEMPLATE_LOCATION.split("/")[1]}/${treeSelectedNode.TEMPLATE?.split(".")?.[0]}`
  //     } else {
  //       newTemplateValue = templateOptions[0]?.props?.value;
  //     }
  //   } else {
  //     newTemplateValue = templateOptions[0]?.props?.value;
  //   }

  //   if (newTemplateValue) {
  //     setTemplateValue(newTemplateValue);
  //     debounceChangeHandler('tval', newTemplateValue);
  //   }
  // }, [templateOptions]);


  return (
    <>
      <Stack direction={"row"} spacing={"4px"} className='stack-row'>
        {obTemplateListLoading ? (
          <LightTooltip
                          title={
                removeJsonExtension(parentNode?.TEMPLATE) && !["EMPTY_COMBO", "SELECT"].includes(selectedTemplateValue) ?
                  `${t("FETCHING_OB_TEMPLATES_FOR_IB_TEMPLATE")}: ${removeJsonExtension(parentNode?.TEMPLATE)}`
                : `${t("FETCHING_OB_TEMPLATES_FOR_IB_TEMPLATE")}`
              }
            placement="top"
          >
            <TextField
              size="small"
              variant="outlined"
              label={t("LBL_TEMP")}
              sx={{height: "34px", width: "100%"}}
              value={
                templateExistsObTemplatesTree ? t(rawTemplateValue) : 
                templateListStr.length > 1 ? t("SELECT") : t("EMPTY_COMBO")
              }
              disabled={true}
              InputProps={{
                sx: {height: "34px", paddingRight: "12px !important"},
                endAdornment: (
                  <CircularProgress size={"14px"} />
                ),
              }}
            />
          </LightTooltip>
        ) : (
          <LabeledDropDown
            label={t("LBL_TEMP")}
            options={correctedDropdownOptions}
            value={templateExistsObTemplatesTree ? rawTemplateValue : 
                   templateListStr.length > 1 ? "SELECT" : "EMPTY_COMBO"}
            onChange={handleTemplateChange}
          />
        )}
        {(
          !templateExistsObTemplatesTree &&
          ["EMPTY_COMBO", "SELECT"].includes(selectedTemplateValue)
        ) ? (
          <LightTooltip
            title={t("OUTBOUND_TEMPLATE_NOT_FOUND")}
            arrow
            placement="right"
          >
            <div style={{ height: "37px" }}>
              <Button
                size='small'
                disabled={
                  (["EMPTY_COMBO", "SELECT"].includes(selectedTemplateValue)
                    // || !templateExistsIbTemplatesTree
                    || obTemplateListLoading
                  )
                }
                variant='outlined'
                sx={{
                  width: "40px",
                  minWidth: "40px",
                  height: "37px"
                }}
                onClick={handleViewTemplateClick}
              >
                {t("MENU_VIEW")}
              </Button>
            </div>
          </LightTooltip>
        ) : (
          <Button
            size='small'
            disabled={(["EMPTY_COMBO", "SELECT"].includes(selectedTemplateValue) || obTemplateListLoading)}
            variant='outlined'
            sx={{
              width: "40px",
              minWidth: "40px",
            }}
            onClick={handleViewTemplateClick}
          >
            {t("MENU_VIEW")}
          </Button>
        )}
      </Stack>
      {/* {(treeSelectedNode && treeSelectedNode.type === "outbound") && (
        <OutboundConditionModal 
          ibTemplate={removeJsonExtension(parentNode?.TEMPLATE) || ""} 
          ibWorkflow={parentNode?.TEMPLATE_LOCATION?.split("/")?.[1] || ""} 
          node={treeSelectedNode} 
          valuesHandler={handleOutboundModalSave}
        />
      )} */}
    </>
  );
};



const styles = {
  getDataNameAdornment: {
    color: "#666666",
    fontSize: "9px",
    position: "absolute",
    right: "13px",
    top: "-6px",
    backgroundColor: "#FFF",
    zIndex: "2",
    padding: "0 5px",
    height: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  treeHeaderContainer: {
    paddingTop: '8px',
    paddingBottom: '2px',
    paddingLeft: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  treeContainer: {
    height: '100%',
    width: '100%',
    border: '1px solid #999',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    borderRadius: '4px',
    minHeight: "161px",
    maxHeight: "161px",
    overflowY: "auto"
  },
  fpContainer: {
    // padding: "0 16px 16px 16px"
    padding: "0 4px 4px 4px",
  },
  accordianContainer: {
    border: "none",
    padding: "0",
    margin: "0",
    boxShadow: "none",
    backgroundColor: "unset",
  },
  accordianHeader: {
    border: "none",
    padding: "0",
    margin: "0",
    backgroundColor: "unset",
  },
  accordianContent: {
    border: "none",
    padding: "0 0px",
    margin: "0",
    backgroundColor: "unset",
  },
};